import { resetSharedStates } from './reducers/shared';
import store from './store';

function stateCleanupLoader({ request }) {
  const dispatch = store.dispatch;

  // Reset all states of redux store
  dispatch(resetSharedStates());

  return null;
}

export { stateCleanupLoader };
